import { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const CancelIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 56 57" {...props}>
            <path
                d="M27.9994 51.8334C40.886 51.8334 51.3327 41.3867 51.3327 28.5001C51.3327 15.6134 40.886 5.16675 27.9994 5.16675C15.1127 5.16675 4.66602 15.6134 4.66602 28.5001C4.66602 41.3867 15.1127 51.8334 27.9994 51.8334Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35 21.5L21 35.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21 21.5L35 35.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
